(function () {
  const pickModal = () => {
    return (
      document.querySelector(".customily-modal-preview-only") ||
      document.querySelector("#cart-preview-modal") ||
      document.querySelector(".customily-preview-modal")
    );
  };

  const pickMain = (modal) =>
    modal.querySelector(".main") ||
    modal.querySelector(".customily_gallery_media") ||
    modal;

  const tryInit = () => {
    const modal = pickModal();
    if (!modal) return false;

    // Avoid double init
    if (modal.dataset.vtEnhanced === "true") return true;

    const main = pickMain(modal);

    // Build heading
    const headingWrap = document.createElement("div");
    headingWrap.className = "customily-modal__preview-heading";
    const title = document.createElement("h3");
    title.className = "customily-modal__title h2";
    title.textContent = "Please check the preview carefully";
    const sub = document.createElement("div");
    sub.className = "customily-modal__text rte";
    sub.innerHTML =
      "<p>Double-tap the uploaded image, if available, to zoom in or out while adjusting it</p><p>Make sure the below customization is correct to receive your item faster</p>";
    headingWrap.appendChild(title);
    headingWrap.appendChild(sub);

    // Actions (only primary button like screenshot)
    const actions = document.createElement("div");
    actions.className = "preview-action";
    const btnAdd = document.createElement("button");
    btnAdd.className =
      "button button--primary button--filled button--primary__filled ld-over-inverse m-spinner-button";
    btnAdd.innerHTML = `
      <span class="m-add-to-cart--text">ADD TO CART</span>
      <span class="m-spinner-icon" style="position: static !important;">
        <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style="width: 16px; height: 16px;">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
    `;
    actions.appendChild(btnAdd);

    // Instruction mobile (removed per request)

    // Wrap container + custom close button at top-right
    const container = document.createElement("div");
    container.className = "customily-modal__container";
    const vtClose = document.createElement("button");
    vtClose.className = "vt-close";
    vtClose.setAttribute("aria-label", "Close");
    vtClose.innerHTML = '<span aria-hidden="true">×</span>';

    // Move structure
    modal.style.padding = "10px 0";
    modal.style.justifyContent = "center";
    const mainEl = pickMain(modal);
    if (mainEl.parentElement !== container) {
      mainEl.prepend(headingWrap);
      mainEl.appendChild(actions);
      container.appendChild(vtClose);
      container.appendChild(mainEl);
      modal.appendChild(container);
    }

    // Bind buttons
    btnAdd.addEventListener("click", () => {
      // Show spinner
      btnAdd.classList.add("m-spinner-loading");
      btnAdd.disabled = true;

      const cartBtn =
        document.getElementById("customily-cart-btn") ||
        document.querySelector("[data-customily-cart-btn]");
      if (cartBtn) cartBtn.click();

      // Hide spinner after a delay or when form is submitted
      const hideSpinner = () => {
        btnAdd.classList.remove("m-spinner-loading");
        btnAdd.disabled = false;
      };

      // Listen for form submission events
      const handleFormSubmit = () => {
        hideSpinner();
        // Close modal only after successful add to cart
        setTimeout(() => {
          const closeBtn = document.querySelector(
            ".customily-close-button, .customily-modal .close, .cl-close"
          );
          if (closeBtn) closeBtn.click();
        }, 300);
      };

      document.addEventListener("product-ajax:added", handleFormSubmit, {
        once: true,
      });
      document.addEventListener(
        "product-ajax:error",
        () => {
          hideSpinner();
        },
        {
          once: true,
        }
      );

      // Fallback: hide spinner after 5 seconds
      setTimeout(() => {
        if (btnAdd.classList.contains("m-spinner-loading")) {
          hideSpinner();
        }
      }, 5000);
    });
    vtClose.addEventListener("click", () => {
      const closeBtn = document.querySelector(
        ".customily-close-button, .customily-modal .close, .cl-close"
      );
      if (closeBtn) closeBtn.click();
    });

    modal.classList.add("vt-enhanced");
    modal.dataset.vtEnhanced = "true";
    return true;
  };

  const boot = () => {
    // Try immediately
    if (tryInit()) return;
    // Observe for later modal injection / re-renders
    const obs = new MutationObserver(() => {
      tryInit();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
